export const {
  format: formatPrice
} = new Intl.NumberFormat('pt-BR', {
  currency: 'BRL',
  style: 'currency'
})